module.exports = __webpack_public_path__ + "assets/img/21_1124.aa0dd39e.jpg";